import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from "react-router-dom"
import { ELEMENTS, queryTools, cn } from "lib/utils"
import { RenderLayout } from "lib/components"
import * as renderopts from "lib/renderers/renderOpts"

const test = [
  { type: "element", refstr: "topbar", seq: 1, level: 1, parent: null, height: "xs" },
  
  { type: "hstack", refstr: "header", seq: 2, level: 1, parent: null, split: [45, 55] },
    { type: "vstack", refstr: "header-left", seq: 1, level: 2, parent: "header", split: [100,100] },
      { type: "element", refstr: "title_block", seq: 1, level: 3, parent: "header-left", height: "sm" },
      { type: "element", refstr: "summary_table", seq: 2, level: 3, parent: "header-left", height: "lg" },
    { type: "vstack", refstr: "header-right", seq: 2, level: 2, parent: "header", split: [100,100] },
      { type: "element", refstr: "mm_logo", seq: 1, level: 3, parent: "header-right", height: "sm" },
      { type: "element", refstr: "summary_block", seq: 2, level: 3, parent: "header-right", height: "lg" },

  { type: "element", refstr: "letter_prefix", seq: 3, level: 1, parent: null, height: "sm" },
  { type: "element", refstr: "opening_statements", seq: 4, level: 1, parent: null, height: "md" },
  { type: "element", refstr: "trx_history", seq: 5, level: 1, parent: null, height: "sm" },
  { type: "element", refstr: "supporting_images", seq: 6, level: 1, parent: null, height: "lg" },
  { type: "element", refstr: "compelling_evidence", seq: 7, level: 1, parent: null, height: "lg" },
  { type: "element", refstr: "detail_screens", seq: 8, level: 1, parent: null, height: "lg" },
  { type: "element", refstr: "policies", seq: 9, level: 1, parent: null, height: "md" },
  { type: "element", refstr: "letter_closing", seq: 10, level: 1, parent: null, height: "sm" },
  { type: "element", refstr: "disclaimer", seq: 11, level: 1, parent: null, height: "sm" }
]


export default function DisputeLayout(){
  const navigate = useNavigate()
  const { dspid } = useParams()

  const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { id: dspid }, { enabled: !!dspid })
  const { data:_Layout } = queryTools.resource.parseQueryForApi("layout.findOne", { name: _Dispute?.layout }, { enabled: !!_Dispute?.layout })

  const [ editorFocus, setEditorFocus ] = useState<any>()

  const handleWireframeClick = (refstr:any) => {
    const renderOptions:any = renderopts
    const opts:any = renderOptions[refstr]
    const elem = ELEMENTS.find((el:any) => el.refstr === refstr)
    setEditorFocus({ elem, opts })
  }

  useEffect(() => {
    if( _Dispute?.layout ){
      console.log(_Dispute)
      console.log(_Layout)
    }
  },[_Dispute, _Layout])

  if( !_Dispute || !_Layout ) return <></>
  return (
    <div className="w-full flex justify-start items-start gap-7 mt-8">
      <div className="w-7/12 flex flex-col">
        <RenderLayout 
          mode="wireframe" 
          handleWireframeClick={handleWireframeClick} 
          editable={true} 
          layout={_Dispute?.structure111 || _Layout?.config.structure} 
        />
      </div>
      <div className="w-5/12 flex flex-col gap-4">
        { editorFocus !== undefined && (
          <>
            <h3 className="text-sm uppercase tracking-wide border-y border-solid border-slate-700 py-1">{editorFocus.elem.title}</h3>
            <p>{editorFocus.elem.description}</p>
            { editorFocus.opts === undefined ? (
              <p>There are rendering options available yet.</p>
            ) : (
              <div className="flex flex-col gap-2">
                <p className="text-yellow-500 px-2">Rendering Options</p>
                { editorFocus.opts.map((opt:any, idx:number) => (
                  <div 
                    key={idx} 
                    className={cn(
                      "flex flex-col gap-0 border border-solid border-transparent p-2 cursor-pointer hover:border-slate-700"
                    )}
                  >
                    <p className="w-full flex justify-between items-center mb-1">
                      <span className="font-bold">{ opt.name }</span>
                      <span>[selected]</span>
                    </p>
                    <p className="italic text-sm mt-0">{ opt.description }</p>
                  </div>
                ))}
              </div>
            )}

            { editorFocus.elem.links.length > 0 && editorFocus.elem.links.map((link:any, idx:number) => (
              <div className="w-full flex flex-col gap-2" key={idx}>
                <p 
                  onClick={() => navigate(link.path.replace("xxxx", dspid))}
                  className="text-yellow-500 px-2 cursor-pointer"
                >
                  {link.label}
                </p>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  )
}